import { render, staticRenderFns } from "./SostieniSquadra.vue?vue&type=template&id=1001dae5&scoped=true"
import script from "./SostieniSquadra.vue?vue&type=script&lang=js"
export * from "./SostieniSquadra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1001dae5",
  null
  
)

export default component.exports